import { createReducer } from "../../common/reduxUtil";

import {
  ARGONAUT,
  GENERATED_SHORTLIST,
  PERSONAL_INFO,
  PLANNER_FORM_DATA,
  PLANNER_ID,
  SELECTED_TAB,
  APPLICATION_FORM_DATA,
  SET_SHORTLISTED_PROGRAMS,
  SELECTED_APPLICATION_TAB,
  FETCHING_SHORTLIST,
  SET_AUTOFILL_STATUS,
  RESET_APPLICATION_FORM_DATA,
} from "./types";

const getInitialApplicationFormData = () => ({
  personalInformation: {
    FirstName: "",
    MiddleName: "",
    LastName: "",
    Mobile: "",
    Gender: "",
    MaritalStatus: "",
    DOB: "",
    countries: [],
    states: [],
    MailingCountry: { label: "India", value: "India" },
    MailingCity: "",
    MailingState: "",
    MailingPinCode: "",
    MailingAddress1: "",
    MailingAddress2: "",
    PermanentCountry: { label: "India", value: "India" },
    PermanentCity: "",
    PermanentState: "",
    PermanentPinCode: "",
    PermanentAddress1: "",
    PermanentAddress2: "",
    PassportNumber: "",
    PassportIssueDate: "",
    PassportExpiryDate: "",
    PassportIssueCountryId: "",
    CityOfBirth: "",
    CountryOfBirth: { label: "India", value: "India" },
    Nationality: "",
    Citizenship: "",
    OtherStudyCountry: "",
    OtherCitizenshipCountry: "",
    ImmigrationCountryValue: "",
    isImmigrationCountryValue: false,
    MedicalConditionValue: "",
    isMedicalConditionValue: false,
    RefusalCountryValue: "",
    isRefusalCountryValue: false,
    CriminalOffenseValue: "",
    isCriminalOffenseValue: false,
    RefusalCountryAdditional: "",
    isMultipleNationality: false,
    isLivingInAnotherCountry: false,
    EmergencyName: "",
    EmergencyPhone: "",
    EmergencyEmail: "",
    RelationWithApplicant: "",
  },
  academicQualification: {
    StudyCountry: { label: "India", value: "India" },
    HighestStudyLevel: "",
    postgraduate: {
      instituteName: "",
      country: { label: "India", value: "India" },
      state: "",
      city: "",
      qualificationAchieved: "",
      gradingPattern: "",
      score: "",
      primaryLanguageOfInstruction: "",
      startDate: "",
      endDate: "",
    },
    undergraduate: {
      instituteName: "",
      country: { label: "India", value: "India" },
      state: "",
      city: "",
      qualificationAchieved: "",
      backlogs: "",
      gradingPattern: "",
      score: "",
      primaryLanguageOfInstruction: "",
      startDate: "",
      endDate: "",
    },
    grade12th: {
      boardName: "",
      instituteName: "",
      country: { label: "India", value: "India" },
      state: "",
      city: "",
      qualificationAchieved: "",
      gradingPattern: "",
      score: "",
      primaryLanguageOfInstruction: "",
      startDate: "",
      endDate: "",
    },
    grade10th: {
      boardName: "",
      instituteName: "",
      country: { label: "India", value: "India" },
      state: "",
      city: "",
      qualificationAchieved: "",
      gradingPattern: "",
      score: "",
      primaryLanguageOfInstruction: "",
      startDate: "",
      endDate: "",
    },
  },
  workExperience: [
    {
      NameOfOrganizationAndAddress: "",
      Position: "",
      JobProfile: "",
      WorkingFrom: "",
      WorkingUpto: "",
      salaryMode: "",
      isPresent: false,
    },
  ],
  tests: {
    currentTest: "",
    invalidFields: {
      gre: {},
      gmat: {},
      toefl: {},
      ielts: {},
      pte: {},
      det: {},
      sat: {},
      act: {},
    },
    gre: null,
    gmat: null,
    toefl: null,
    ielts: null,
    pte: null,
    det: null,
    sat: null,
    act: null,
  },
});

const initialState = {
  selectedTab: -1,
  selectedApplicationTab: 0,
  personalInfo: {},
  plannerFormData: null,
  argonautLeadId: null,
  generatedShortlist: null,
  shortlistedPrograms: null,
  fetchingShortlist: true,
  applicationFormData: getInitialApplicationFormData(),
  autofill: {
    documentExtractions: [],
  },
};

export default createReducer(initialState, {
  [SELECTED_TAB]: (state, payload) => {
    return Object.assign({}, state, {
      selectedTab: payload,
    });
  },

  [SELECTED_APPLICATION_TAB]: (state, payload) => {
    return Object.assign({}, state, {
      selectedApplicationTab: payload,
    });
  },

  [PERSONAL_INFO]: (state, payload) => {
    return Object.assign({}, state, {
      personalInfo: { ...state.personalInfo, ...payload },
    });
  },

  [GENERATED_SHORTLIST]: (state, payload) => {
    return Object.assign({}, state, {
      generatedShortlist: payload,
    });
  },

  [SET_SHORTLISTED_PROGRAMS]: (state, payload) => {
    return Object.assign({}, state, {
      shortlistedPrograms: payload,
    });
  },

  [FETCHING_SHORTLIST]: (state, payload) => {
    return Object.assign({}, state, {
      fetchingShortlist: payload,
    });
  },

  [PLANNER_ID]: (state, payload) => {
    return Object.assign({}, state, {
      plannerId: payload,
    });
  },

  [PLANNER_FORM_DATA]: (state, payload) => {
    return Object.assign({}, state, {
      plannerFormData: payload,
    });
  },

  [ARGONAUT]: (state, payload) => {
    return Object.assign({}, state, {
      argonautLeadId: payload.leadId,
    });
  },

  [APPLICATION_FORM_DATA]: (state, action) => {
    // Coerce workExperience to array — MongoDB $set with dot-notation
    // can create it as an object {0: {...}, 1: {...}} instead of an array
    const rawWE = action?.workExperience;
    const workExp = rawWE && !Array.isArray(rawWE) && typeof rawWE === "object"
      ? Object.keys(rawWE).sort((a, b) => Number(a) - Number(b)).map(k => rawWE[k])
      : rawWE;

    return {
      ...state,
      applicationFormData: {
        ...state.applicationFormData,
        workExperience: workExp
          ? !workExp[0]?.workExperienceIndex
            ? [...workExp]
            : state.applicationFormData?.workExperience.map((obj, i) => {
                if (i === workExp[0].workExperienceIndex) {
                  return workExp[0];
                }
                return obj;
              })
          : state.applicationFormData?.workExperience,

        ...Object.keys(action).reduce((acc, key) => {
          if (key !== "workExperienceIndex" && key !== "workExperience") {
            acc[key] = {
              ...state.applicationFormData[key],
              ...action[key],
            };
          }
          return acc;
        }, {}),
      },
    };
  },

  [SET_AUTOFILL_STATUS]: (state, payload) => {
    return {
      ...state,
      autofill: {
        ...state.autofill,
        documentExtractions: payload.documentExtractions || [],
      },
    };
  },

  [RESET_APPLICATION_FORM_DATA]: (state) => {
    return {
      ...state,
      applicationFormData: getInitialApplicationFormData(),
      autofill: {
        documentExtractions: [],
      },
    };
  },

});
